// Custom Plugins Include
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

$.fn.extend({
  animateCss: function animateCss(animationName, endFunction) {
    var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
    this.addClass('animated ' + animationName).one(animationEnd, function () {
      if (typeof endFunction == "function") {
        endFunction.call();
      }
      $(this).removeClass('animated ' + animationName);
    });
    return this;
  },
  animateCounter: function animateCounter(_params) {
    /* const $display = $(this);
       var params = $.extend({
         delay: 80,
         startDataAttr: "start",
         endDataAttr: "end"
     }, _params);
       const start = $display.data(params.startDataAttr);
     const numberEnd = $display.data(params.endDataAttr);
       for (let i = start; i <= numberEnd; i++) {
         setTimeout(function () {
             $display.text(i);
         }, params.delay * i)
     }
       return $display;*/
  }
});
"use strict";

(function ($) {
  $.fn.toggleText = function (_params) {

    var params = $.extend({
      statefun: false
    }, _params);

    var $toggle = this;
    var text = "";

    $toggle.text(function (i, text) {
      if ($toggle.attr("data-text")) {
        text = $(this).data("text");
        $toggle.removeAttr("data-text");
      } else {
        $toggle.attr("data-text", text);
        text = $toggle.data("toggle");
      }
      return text;
    });

    return $toggle;
  };
})(jQuery);
"use strict";

(function ($) {
  $.fn.scrollTo = function (_params) {

    var params = $.extend({
      speed: "slow"
    }, _params);

    var $link = this;
    var link = $link.attr("href");

    $('html,body').animate({
      scrollTop: $(link).offset().top
    }, params.speed);

    return $link;
  };
})(jQuery);
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user = getCookie("username");
  if (user != "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}

var MoreItems = function () {
  function MoreItems(opts) {
    var _this = this;

    _classCallCheck(this, MoreItems);

    if (opts instanceof Object) {
      this.wrapper = opts.wrapper.nodeType != 1 ? document.getElementById(opts.wrapper) : opts.wrapper;
      if (this.wrapper) {
        this.items = this.wrapper.getElementsByClassName(opts.items);
        this.moreBtn = opts.moreBtn.nodeType != 1 ? document.getElementById(opts.moreBtn) : opts.moreBtn;
        this.hiddenClass = opts.hiddenClass || "hidden";
        this.visibleCount = opts.visibleCount || 1;
        this.hiddenItems = [];
        if (this.items.length > this.visibleCount) {
          this.init();
          this.moreBtn.onclick = function () {
            return _this.moreItems();
          };
        } else {
          this.moreBtn.addClass(this.hiddenClass);
        }
      }
    } else {
      console.log("MoreItems Parameter Error!");
    }
  }

  _createClass(MoreItems, [{
    key: 'init',
    value: function init() {

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        if (i + 1 > this.visibleCount) {
          item.classList.add(this.hiddenClass);
          this.hiddenItems.push(item);
        }
      }
    }
  }, {
    key: 'moreItems',
    value: function moreItems() {

      var visibledItems = this.hiddenItems.splice(0, this.visibleCount);
      if (visibledItems.length > 0) {
        for (var i = 0; i < visibledItems.length; i++) {
          var item = visibledItems[i];
          item.classList.remove(this.hiddenClass);
        }
      } else {
        this.moreBtn.classList.add(this.hiddenClass);
      }
    }
  }]);

  return MoreItems;
}();
// Components


var $firstIsMobile = $(window).width() < 768 ? true : false;
var tl = new TimelineMax();
var videos = [],
    reqIds = [],
    videoStatus = [];

function startPlayback(container, index) {
  if (!videos[index]) {
    videos[index] = document.createElement('video');
    var video = videos[index];
    video.muted = true;
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    video.setAttribute('playsinline', true);
    video.allowsInlineMediaPlayback = true;
    video.loop = true;
    video.autoplay = true;
    var sourcemp4 = document.createElement("source");
    sourcemp4.setAttribute("type", "video/mp4");
    var sourcewebm = document.createElement("source");
    sourcewebm.setAttribute("type", "video/webm");
    var sourceogg = document.createElement("source");
    sourceogg.setAttribute("type", "video/ogg");
    if ($firstIsMobile) {
      video.poster = $(container).data("poster-mobile");
      if ($(container).data("mobile-mp4") != "") {
        sourcemp4.setAttribute("src", $(container).data("mobile-mp4"));
        video.appendChild(sourcemp4);
      }
      if ($(container).data("mobile-webm") != "") {
        sourcewebm.setAttribute("src", $(container).data("mobile-webm"));
        video.appendChild(sourcewebm);
      }
      if ($(container).data("mobile-ogg") != "") {
        sourceogg.setAttribute("src", $(container).data("mobile-ogg"));
        video.appendChild(sourceogg);
      }
    } else {
      video.poster = $(container).data("poster");
      if ($(container).data("mp4") != "") {
        sourcemp4.setAttribute("src", $(container).data("mp4"));
        video.appendChild(sourcemp4);
      }
      if ($(container).data("webm") != "") {
        sourcewebm.setAttribute("src", $(container).data("webm"));
        video.appendChild(sourcewebm);
      }
      if ($(container).data("ogg") != "") {
        sourceogg.setAttribute("src", $(container).data("ogg"));
        video.appendChild(sourceogg);
      }
    }
    container.appendChild(video);
    video.addEventListener('loadedmetadata', function () {
      video.play();
    }, false);
  } else {
    //videos[index].muted = false;
    startVideo(container, index);
  }
}

function toogleMutedVideo(index) {
  videos[index].muted = !videos[index].muted;
}

function stopVideo(index) {
  cancelAnimationFrame(reqIds[index]);
  if (!videos[index].paused) {
    videos[index].pause();
  }
}

function startVideo(container, index) {
  if (videos.length >= index) {
    if (videos[index].paused) {
      videos[index].play();
    }
  }
}
var $bigSlider = $("#big-slider");

$bigSlider.on('init', function (event, slick) {
  var AnimItems = $(slick.$slides.slice(1, slick.$slides.length)),
      slidesOut = [AnimItems.find("span"), AnimItems.find(".animation h1"), AnimItems.find(".animation p")];
  TweenMax.set(slidesOut, {
    alpha: 0
  });
  var firstSlide = $(slick.$slides[0]);
  var link = firstSlide.data("link");
  var video = firstSlide.find(".video");
  var dataBg = $firstIsMobile ? "mobile-bg" : "bg";
  var dataPoster = $firstIsMobile ? "poster-mobile" : "poster";
  $.each(slick.$slides, function (index, slideItem) {
    if ($(slideItem).find(".slide-bg").length > 0) {
      var $slideBg = $(slideItem).find(".slide-bg");
      $slideBg.css("background-image", "url(" + $slideBg.data(dataBg) + ")");
    }
  });
  if (video.length > 0) {
    startPlayback(video[0], 0);
  }
  $("#slider-detail-btn").attr("href", link);
  $("#big-slider-wrapper").find(".slick-prev").on("click", function () {
    $bigSlider.slick('slickPrev');
  });
  $("#big-slider-wrapper").find(".slick-next").on("click", function () {
    $bigSlider.slick('slickNext');
  });
}).slick({
  infinite: true,
  autoplay: true,
  fade: true,
  speed: 800,
  autoplaySpeed: 7000,
  dots: true,
  arrows: false
}).on("setPosition", function (slick) {
  var height = this.offsetHeight;
  $(this.slick.$slides).css("height", height + "px");
  $(this.slick.$slides).find(".slide-bg img").hide();
}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  var slidesOut = [$(slick.$slides[currentSlide]).find("span"), $(slick.$slides[currentSlide]).find(".animation h1"), $(slick.$slides[currentSlide]).find(".animation p")],
      slidesIn = [$(slick.$slides[nextSlide]).find("span"), $(slick.$slides[nextSlide]).find(".animation h1"), $(slick.$slides[nextSlide]).find(".animation p")];
  tl.insert(TweenMax.to(slidesOut, 1, {
    alpha: 0,
    yoyo: true,
    ease: Power1.easeOut
  }), "-=.4");
  tl.insert(TweenMax.to(slidesIn, 1, {
    alpha: 1,
    yoyo: true,
    ease: Power1.easeIn
  }), "-=.4");
  var video = $(slick.$slides[currentSlide]).find(".video");
  if (video.length > 0) {
    stopVideo(currentSlide);
  }
}).on('afterChange', function (event, slick, currentSlide, nextSlide) {
  var link = $(slick.$slides[currentSlide]).data("link");
  $("#slider-detail-btn").attr("href", link);
  var video = $(slick.$slides[currentSlide]).find(".video");
  if (video.length > 0) {
    startPlayback(video[0], currentSlide);
  }
});
// Slide Events
var $eventSlider = $(".events-slider");
$eventSlider.each(function (index, item) {
  var navigation = $(item).data("navigation");
  var navigationBar = $(".navigation-bar[data-navigation=" + navigation + "]")[0];
  var $leftNav = $(navigationBar).find(".btn-navigation.prev");
  var $rigtNav = $(navigationBar).find(".btn-navigation.next");
  $(item).slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {}).on('afterChange', function (event, slick, currentSlide, nextSlide) {
    var link = $(".slick-slide").eq(currentSlide).data("link");
  });
  $leftNav.on("click", function (e) {
    $(item).slick("slickPrev");
    e.preventDefault();
  });
  $rigtNav.on("click", function (e) {
    $(item).slick("slickNext");
    e.preventDefault();
  });
});

// Etkinlik Takvimi İçindeki Sliderlar

function eventCalendar(language) {

  var btn = $("#event-calendar-btn");
  $(btn).find('span[data-toggle]').toggleText();
  if ($(btn).hasClass("active")) {
    $(btn).find(".icon").addClass("icon-calendar").removeClass("icon-cross animated bounceIn");
    $(btn).removeClass("active");
  } else {
    $(btn).find(".icon").removeClass("icon-calendar").addClass("icon-cross animated bounceIn");
    $(btn).addClass("active");
  }

  // Etkinlik Takvimini Açıp Kapatır
  var $eventFull = $(".event-full");
  if ($eventFull.hasClass("active")) {
    $(".navigation-bar[data-navigation=home-event-navigation] .btn-navigation").removeClass("disable");
    $eventFull.removeClass("active");
  } else {
    $(".navigation-bar[data-navigation=home-event-navigation] .btn-navigation").addClass("disable");
    $eventFull.addClass("active");
  }

  var url = 'http://tarabya.cms.pixelplus.org/eventsxml?q=' + language,
      monthNames = language == "en_" ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] : ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
      dayNames = language == "en_" ? ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] : ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"],
      currentYear = new Date().getUTCFullYear();
  var events = [],
      monthList = [],
      eventList = [];
  $.get(url, function (res) {
    events = $(res).find("items").find("item");
  }).done(function () {
    var eventDates = events.find("EventType").find("EventDate");

    var _loop = function _loop() {
      var _date = new Date(eventDates[i].textContent),
          monthNumber = _date.getUTCMonth() + 1,
          yearNumber = _date.getUTCFullYear();

      if (monthList.indexOf(monthNumber) == -1) {
        monthList.push(monthNumber);
        var monthName = monthNames[monthNumber - 1],
            eventDayList = [],
            _tempObj = {
          monthName: monthName,
          year: yearNumber,
          monthNumber: monthNumber,
          monthEvents: [],
          sort_index: monthNumber
        };

        var filterEvent = events.find("EventType").filter(function (index) {
          var itemDate = new Date($(this).find("EventDate")[0].textContent);
          if (itemDate.getUTCMonth() + 1 == monthNumber) {
            var day = itemDate.getUTCDate();
            var event = {
              date: {
                full: itemDate,
                day: day,
                dayName: dayNames[itemDate.getDay() - 1],
                month: monthNumber,
                monthName: monthName,
                year: yearNumber,
                time: itemDate.getHours() + ":" + itemDate.getMinutes()
              },
              title: $(this).find("EventTitle")[0].textContent,
              cover: $(this).find("EventCoverImage")[0].textContent
            };

            if (eventDayList.indexOf(day) < 0) {
              eventDayList.push(day);
              _tempObj.monthEvents.push({
                dayNumber: day,
                dayEvents: [event],
                sort_index: day
              });
            } else {
              var result = $.grep(_tempObj.monthEvents, function (e) {
                return e.dayNumber == day;
              });
              result[0].dayEvents.push(event);
            }
          }
        });

        eventList.push(_tempObj);
      }
    };

    for (var i = 0; i < eventDates.length; i++) {
      _loop();
    }

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '/assets/lib/handlebars-v4.0.5.js';
    document.body.appendChild(script);

    script.onload = function () {

      Handlebars.registerHelper('each_with_sort', function (context, opts) {
        var sorteddata = context.sort(function (a, b) {
          return a.sort_index > b.sort_index;
        });
        var result = "";
        sorteddata.forEach(function (element) {
          result += opts.fn(element);
        });
        return result;
      });

      console.log(eventList);

      var source = document.getElementById("event-calander-template").innerHTML;
      var template = Handlebars.compile(source);
      var theCompiledHtml = template({
        eventList: eventList
      });

      document.getElementById("event-calendar-content").innerHTML = theCompiledHtml;

      // Sliderlar

      // Event Full Slider
      var $eventFullSlider = $(".event-full-slider");
      $.each($eventFullSlider, function (index, item) {
        var navigation = $(item).data("navigation");
        var navigationBar = $(".navigation-bar[data-navigation=" + navigation + "]")[0];
        var $monthName = $(navigationBar).find(".month");
        var $leftNav = $(navigationBar).find(".btn-navigation.prev");
        var $rigtNav = $(navigationBar).find(".btn-navigation.next");
        $(item).on("init", function (event, slick) {
          var monthName = slick.$slides.eq(0).data("month");
          $monthName.text(monthName);
        }).slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: false,
          swipe: false,
          touchMove: false,
          dots: false,
          accessibility: false
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var slider = slick.$slider[0];
          if ($(slider).hasClass("event-full-slider")) {
            var monthName = $(item).find(".event-full-slide-item").eq(nextSlide).data("month");
            $monthName.text(monthName);
          }
        });

        if ($(item).hasClass("event-full-slider")) {
          // Bulunulan Ayın Etkinliklerine Gider
          var date = new Date();
          var _monthNumber = date.getMonth() + 1;
          var slides = item.slick.$slides;
          var currentMonth = slides.filter(function () {
            return $(this).data("goto-month") == _monthNumber;
          });
          var currentMontSlideItem = currentMonth.data("slick-index");
          $(this).slick('slickGoTo', currentMontSlideItem ? parseInt(currentMontSlideItem) : slides.length);
        }

        $leftNav.on("click", function (e) {
          $(item).slick("slickPrev");
          e.preventDefault();
        });
        $rigtNav.on("click", function (e) {
          $(item).slick("slickNext");
          e.preventDefault();
        });
      });

      // Event Detail Slider
      var $eventDetailSlider = $(".event-detail-slider");

      $.each($eventDetailSlider, function (index, item) {
        var navigation = $(item).data("navigation");
        var navigationBar = $(".navigation-bar[data-navigation=" + navigation + "]");
        var $leftNav = $(navigationBar).find(".btn-navigation.prev");
        var $rigtNav = $(navigationBar).find(".btn-navigation.next");

        $(item).slick({
          infinite: false,
          slidesToShow: 5,
          slidesToScroll: 5,
          arrows: false,
          autoplay: false,
          swipe: false,
          touchMove: false,
          dots: false,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              centerMode: true
            }
          }, {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              centerMode: true
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              touchMove: false,
              swipe: true
            }
          }]
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var slider = slick.$slider[0];
          if ($(slider).hasClass("event-detail-slider")) {}
          if (currentSlide < nextSlide) {
            // Sağa Çekildi Direction Right
          }
          if (currentSlide > nextSlide) {
            // Sola Çekildi Direction Left
          }
        }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
          var slider = slick.$slider[0];
          if ($(slider).hasClass("event-detail-slider")) {
            $(item).addClass("anim-end");
          }
        });
        $leftNav.on("click", function (e) {
          $(item).slick("slickPrev");
        });
        $rigtNav.on("click", function (e) {
          $(item).slick("slickNext");
        });
      });

      // Event Day Slider
      var $eventDaySlider = $(".event-day-slider");
      $.each($eventDaySlider, function (index, item) {
        $(item).slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          dots: true,
          autoplaySpeed: 7000,
          speed: 2000
        });
      });
      // Slider Bitiş

    };
  });
}

// Event List Page
var eventListPageSelector = document.getElementById("eventlistpage");
if (eventListPageSelector) {

  var _language = "_en";

  var url = 'http://tarabya-en.cms.pixelplus.org/eventsxml?q=' + _language,
      monthNames = _language == "en_" ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] : ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
      dayNames = _language == "en_" ? ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] : ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"],
      currentYear = new Date().getUTCFullYear();
  var events = [],
      monthList = [],
      eventList = [];
  $.get(url, function (res) {
    events = $(res).find("items").find("item");
  }).done(function () {
    var eventDates = events.find("EventType").find("EventDate");

    var _loop2 = function _loop2() {
      var _date = new Date(eventDates[i].textContent),
          monthNumber = _date.getUTCMonth() + 1,
          yearNumber = _date.getUTCFullYear();

      if (monthList.indexOf(monthNumber) == -1) {
        monthList.push(monthNumber);
        var monthName = monthNames[monthNumber - 1],
            eventDayList = [],
            _tempObj = {
          monthName: monthName,
          year: yearNumber,
          monthNumber: monthNumber,
          monthEvents: [],
          sort_index: monthNumber
        };

        var filterEvent = events.find("EventType").filter(function (index) {
          var itemDate = new Date($(this).find("EventDate")[0].textContent);
          if (itemDate.getUTCMonth() + 1 == monthNumber) {
            var day = itemDate.getUTCDate();
            var event = {
              date: {
                full: itemDate,
                day: day,
                dayName: dayNames[itemDate.getDay() - 1],
                month: monthNumber,
                monthName: monthName,
                year: yearNumber,
                time: itemDate.getHours() + ":" + itemDate.getMinutes()
              },
              title: $(this).find("EventTitle")[0].textContent,
              cover: $(this).find("EventCoverImage")[0].textContent
            };

            if (eventDayList.indexOf(day) < 0) {
              eventDayList.push(day);
              _tempObj.monthEvents.push({
                dayNumber: day,
                dayEvents: [event],
                sort_index: day
              });
            } else {
              var result = $.grep(_tempObj.monthEvents, function (e) {
                return e.dayNumber == day;
              });
              result[0].dayEvents.push(event);
            }
          }
        });

        eventList.push(_tempObj);
      }
    };

    for (var i = 0; i < eventDates.length; i++) {
      _loop2();
    }

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '/assets/lib/handlebars-v4.0.5.js';
    document.body.appendChild(script);

    script.onload = function () {
      Handlebars.registerHelper('each_with_sort', function (context, opts) {
        var sorteddata = context.sort(function (a, b) {
          return a.sort_index > b.sort_index;
        });
        var result = "";
        sorteddata.forEach(function (element) {
          result += opts.fn(element);
        });
        return result;
      });

      var source = document.getElementById("event-calander-template").innerHTML;
      var template = Handlebars.compile(source);
      var theCompiledHtml = template({
        eventList: eventList
      });

      document.getElementById("eventlistpage").innerHTML = theCompiledHtml;
    };
  });
}
var $anonceSlider = $(".anonce-slider");

$.each($anonceSlider, function (index, item) {
  var navigation = $(item).data("navigation");
  var navigationBar = $(".navigation-bar[data-navigation=" + navigation + "]")[0];
  var $leftNav = $(navigationBar).find(".btn-navigation.prev");
  var $rigtNav = $(navigationBar).find(".btn-navigation.next");

  $(item).on('init', function () {}).slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000
  });

  $leftNav.on("click", function (e) {
    $(item).slick("slickPrev");
    e.preventDefault();
  });

  $rigtNav.on("click", function (e) {
    $(item).slick("slickNext");
    e.preventDefault();
  });
});
var $newsSlider = $(".news-slider");

$.each($newsSlider, function (index, item) {
  var navigation = $(item).data("navigation");
  var navigationBar = $(".navigation-bar[data-navigation=" + navigation + "]")[0];
  var $leftNav = $(navigationBar).find(".btn-navigation.prev");
  var $rigtNav = $(navigationBar).find(".btn-navigation.next");
  $(item).on("init", function () {
    $(item).find(".slick-slide .animation-content, .slick-slide article").addClass("animated");
  }).slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {}).on('afterChange', function (event, slick, currentSlide, nextSlide) {});
  $leftNav.on("click", function (e) {
    $(item).slick("slickPrev");
    e.preventDefault();
  });
  $rigtNav.on("click", function (e) {
    $(item).slick("slickNext");
    e.preventDefault();
  });
});
var $brandingSlider = $(".branding-slider");
var $sliderContainer = $('#branding-scroll');

$.each($brandingSlider, function (index, item) {
  $(item).on("init", function () {}).slick({
    autoplay: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    speed: 5000,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: true
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }],
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow"><i class="icon icon-chevron-left"></i></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow"><i class="icon icon-chevron-right"></i></button>'
  });

  if ($sliderContainer.length > 0) {
    var sliderPosition = $sliderContainer[0].offsetTop;

    $(window).on('scroll', function () {
      var current = $(document).scrollTop();
      if (current >= sliderPosition) {
        $(item).slick('slickPlay');
      }
    });
  }
});
var $campusSlider = $("#campus-slider"),
    $campusListSlider = $(".campusimageslider");

$campusListSlider.slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 5,
  arrows: false,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: true
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});

$campusSlider.slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: false,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: true
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});
//=include "contact-box.js"
var $gallerySlider = $(".gallery-slider");

$.each($gallerySlider, function (index, item) {
  var randomSpeed = Math.floor(Math.random() * 8000 + 1000);
  $(item).slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: randomSpeed
  });
});
var $figureSlider = $(".slider");

$.each($figureSlider, function (index, item) {
  $(item).slick({
    autoplaySpeed: 2000,
    speed: 2000,
    delay: 1000,
    autoplay: false, //new Boolean($(item).data("autoplay")),
    infinite: false,
    slidesToShow: $(item).data("slidestoshow"),
    slidesToScroll: $(item).data("slidestoscroll"),
    arrows: true,
    centerMode: false,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow"><i class="icon icon icon-chevron-left"></i></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow"><i class="icon icon icon-chevron-right"></i></button>',
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    }]
  });
});
var $infoGraphicSlider = $(".info-graphic-slider");
$.each($infoGraphicSlider, function (index, item) {
  var navigation = $(item).data("navigation");
  var navigationBar = $(".navigation-bar[data-navigation=" + navigation + "]")[0];
  var $leftNav = $(navigationBar).find(".btn-navigation.prev");
  var $rigtNav = $(navigationBar).find(".btn-navigation.next");

  $(item).on('init', function (event, slick) {
    var counterDisplay = slick.$slides[0].getElementsByClassName("number-counter")[0],
        startNumber = counterDisplay.getAttribute('data-start'),
        scoreCounter = {
      score: startNumber
    },
        endNumber = counterDisplay.getAttribute('data-end');
    TweenLite.to(scoreCounter, 1, {
      score: endNumber,
      roundProps: "score",
      onUpdate: function onUpdate() {
        counterDisplay.innerHTML = scoreCounter.score;
      },
      ease: Linear.easeNone
    });
  }).slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    fade: true,
    autoplaySpeed: 4000,
    speed: 1000
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var counterDisplay = slick.$slides[nextSlide].getElementsByClassName("number-counter")[0],
        startNumber = counterDisplay.getAttribute('data-start'),
        scoreCounter = {
      score: startNumber
    },
        endNumber = counterDisplay.getAttribute('data-end');
    TweenLite.to(scoreCounter, 1, {
      score: endNumber,
      roundProps: "score",
      onUpdate: function onUpdate() {
        counterDisplay.innerHTML = scoreCounter.score;
      },
      ease: Linear.easeNone
    });
  });
  $leftNav.on("click", function (e) {
    $(item).slick("slickPrev");
    e.preventDefault();
  });

  $rigtNav.on("click", function (e) {
    $(item).slick("slickNext");
    e.preventDefault();
  });
});
slickInit();
$(window).resize(function () {
  if ($firstIsMobile == true) {
    if ($(window).width() >= 768) {
      $("#media-slider").slick('unslick');
      slickInit();
      $firstIsMobile = false;
    }
  } else {
    if ($(window).width() < 768) {
      $("#media-slider").slick('unslick');
      slickInit();
      $firstIsMobile = true;
    }
  }
});

function slickInit() {
  var row = 2;
  var rowVal = $(window).width() < 768 ? 1 : 2;
  if (rowVal == 1 || $("#media-slider").find(".slide-item").length < 9) {
    row = 1;
  }
  $("#media-slider").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow"><i class="icon icon icon-chevron-left"></i></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow"><i class="icon icon icon-chevron-right"></i></button>',
    autoplay: false,
    rows: row,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    }]
  });
}
var $videoSlider = $(".video-slider");

/*$.each($videoSlider, function (index, item) {
  let navigation = $(item).data("navigation");
  let navigationBar = $(".navigation-bar[data-navigation=" + navigation + "]")[0];
  let $leftNav = $(navigationBar).find(".btn-navigation.prev");
  let $rigtNav = $(navigationBar).find(".btn-navigation.next");
  $(item).slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {

      let $currentSlideItem = $(item).find(".slick-slide").eq(currentSlide);
      let $currentVideoItems = $currentSlideItem.find(".video");
    });
  $leftNav.on("click", function (e) {
    $(item).slick("slickPrev");
    e.preventDefault();
  });
  $rigtNav.on("click", function (e) {
    $(item).slick("slickNext");
    e.preventDefault();
  });
});*/
$(".accredition-vertical .detailbtn").on("click", function () {
  $($(this).parents(".accredition-vertical")[0]).toggleClass("open");
});
$.each($(".tab"), function (index, tab) {
  $(this).find(".tab-menu a").on("click", function () {
    $(tab).find(".tab-menu a").removeClass("active");
    $(this).addClass("active");
    $(tab).find(".tab-content").removeClass("active");
    $(tab).find(".tab-content").eq($(this).index()).addClass("active");
  });
});
if ($("#mezun-slider").length > 0) {
  $("#mezun-slider").on('init', function (event, slick) {
    var CurrentSlideItem = slick.$slides[0];
    var year = $(CurrentSlideItem).data("mezunyear");
    $("#mezun-year").text(year);
    $("#mezun-filter-counter").text($(CurrentSlideItem).find(".graduated-box").length);
  }).slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    adaptiveHeight: true
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var CurrentSlideItem = slick.$slides[nextSlide];
    var year = $(CurrentSlideItem).data("mezunyear");
    $("#mezun-year").text(year);
    $("#mezun-filter-counter").text($(CurrentSlideItem).find(".graduated-box").length);
  });
  $("#mezun-slider-left-btn").on("click", function (e) {
    $("#mezun-slider").slick("slickPrev");
    e.preventDefault();
  });
  $("#mezun-slider-right-btn").on("click", function (e) {
    $("#mezun-slider").slick("slickNext");
    e.preventDefault();
  });
}
if ($("#mezun-slider-filter").length > 0) {
  $("#mezun-slider-filter").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    autoplay: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow"><i class="icon icon icon-chevron-left"></i></button>',
        nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow"><i class="icon icon icon-chevron-right"></i></button>'
      }
    }]
  });
  $("#mezun-slider-filter-left-btn").on("click", function (e) {
    $("#mezun-slider-filter").slick("slickPrev");
    e.preventDefault();
  });
  $("#mezun-slider-filter-right-btn").on("click", function (e) {
    $("#mezun-slider-filter").slick("slickNext");
    e.preventDefault();
  });
}
$(".comment-slider").slick({
  autoplaySpeed: 2000,
  speed: 2000,
  delay: 1000,
  fade: true,
  autoplay: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true
    }
  }]
});

$("#digerbasarilar-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: false,
  autoplay: false,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow"><i class="icon icon icon-chevron-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow"><i class="icon icon icon-chevron-right"></i></button>'
    }
  }]
});

var logoSlider = function logoSlider() {
  var $selector = $('.logo-slider');
  $selector.slick({
    infinite: true,
    dots: false,
    slidesToShow: 8,
    slidesToScroll: 8,
    centerMode: false,
    arrows: false,
    variableWidth: false,
    rows: 0,
    responsive: [{
      breakpoint: 800,
      settings: {
        centerMode: true,
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }, {
      breakpoint: 468,
      settings: {
        arrows: true,
        centerMode: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }]
  });
};
var recaptchaControl = void 0;
var recaptchaInit = function recaptchaInit() {
  recaptchaControl = grecaptcha.render('recaptcha');
};

function fileinput(file, infocontent) {
  if (file.files[0]) {
    document.getElementById(infocontent).innerText = file.files[0].name;
  } else {
    document.getElementById(infocontent).innerText = "Dosya Seçilmedi.";
  }
}

function tbsVelileriForm(token) {

  var form = $("#tbsVelileriForm"),
      createData = new FormData();

  $(form).serializeArray().forEach(function (field) {
    if (field.name) {
      createData.append(field.name, field.value);
    }
  });

  $(form).find("input[type='file']").each(function (index, file) {
    createData.append($(file).attr("name"), file.files[0]);
  });

  var url = form.attr("action"),
      method = form.attr("method");

  $(form).find(".loading-btn").attr("disabled", "disabled");
  $(form).find(".loading-btn .loadingcontent").removeClass("hidden");

  createData.append("Captcha", grecaptcha.getResponse(recaptchaControl));

  setTimeout(function () {
    $.ajax({
      url: url,
      type: method,
      dataType: "json",
      async: false,
      cache: false,
      contentType: false,
      processData: false,
      data: createData,
      success: function success(res) {
        console.log(res);
        if (res.data.IsLogin == false) {
          setCookie("login", false, 30);
          window.loginOpen();
        } else {
          setCookie("login", true, 30);
          window.loginClose();
          if (res.success) {
            $("#tbsvelileriform-message").removeClass("hidden");
            $("#tbsvelileriform").addClass("hidden");
            $("html, body").animate({
              scrollTop: $("#banner").height()
            }, 'slow');
          } else {
            console.log(res);
          }
        }
      },
      error: function error(err) {
        console.log(err);
      },
      complete: function complete() {
        $(form).find(".loading-btn").removeAttr("disabled");
        $(form).find(".loading-btn .loadingcontent").addClass("hidden");
      }
    });
  }, 2);
}

function randevuForm(token) {

  var form = $("#randevuForm"),
      createData = new FormData();

  $(form).serializeArray().forEach(function (field) {
    if (field.name) {
      createData.append(field.name, field.value);
    }
  });

  var url = form.attr("action"),
      method = form.attr("method");

  createData.append("Captcha", grecaptcha.getResponse(recaptchaControl));

  $.ajax({
    url: url,
    type: method,
    dataType: "json",
    async: false,
    cache: false,
    contentType: false,
    processData: false,
    data: createData,
    success: function success(res) {
      if (res.success) {
        $(".message").removeClass("hidden");
        $("#randevuFormContent").addClass("hidden");
      } else {
        console.log(res);
      }
    },
    error: function error(err) {
      console.log(err);
    }
  });
}

function loginForm() {

  var form = $("#loginForm"),
      createData = new FormData();

  $(form).serializeArray().forEach(function (field) {
    if (field.name) {
      createData.append(field.name, field.value);
    }
  });

  var url = form.attr("action"),
      method = form.attr("method");
  $.ajax({
    url: url,
    type: method,
    dataType: "json",
    async: false,
    cache: false,
    contentType: false,
    processData: false,
    data: createData,
    success: function success(res) {
      console.log(res);
      if (res.data.isLogin) {
        form.find(".form-error").html("");
        setCookie("login", true, 30);
        setCookie("sinif", res.data.className, 30);
        $("#tbsVelileriForm input[name='classname']").val(res.data.className);
        window.loginClose();
        $("#unautorize").addClass("hidden");
        $("#login").removeClass("hidden");
        if (grecaptcha.getResponse() != "") {
          grecaptcha.reset();
          grecaptcha.execute();
        }
      } else {
        var errormessage = language == 'tr' ? "Lütfen Bilgilerinizi Kontrol Ediniz!" : "Please Check Your Details!";
        form.find(".form-error").html(errormessage);
        setCookie("login", false, 30);
        setCookie("sinif", "", 0);
      }
    },
    error: function error(err) {
      form.find(".form-error").html(language == 'tr' ? "Sistemde bir hata oluştu, Lütfen tekrar deneyiniz" : "An error has occurred in the system, please try again");
      console.log(err);
    },
    beforeSend: function beforeSend() {
      $(form).find(".loading-btn").attr("disabled", true);
      $(form).find(".loading-btn .loadingcontent").removeClass("hidden");
    },
    complete: function complete() {
      $(form).find(".loading-btn").attr("disabled", false);
      $(form).find(".loading-btn .loadingcontent").addClass("hidden");
    }
  });
}

function formdata(form, event) {
  event.preventDefault();
  var control = true;
  for (var i = 0; i < form.elements.length; i++) {
    var formItem = form.elements[i];
    var itemValue = formItem.value,
        itemName = formItem.getAttribute("name"),
        itemReq = formItem.dataset.required,
        itemRegExp = formItem.dataset.pattern,
        itemRegExpMessage = formItem.dataset.patternmessage,
        regex = new RegExp(itemRegExp, 'g'),
        itemMask = formItem.dataset.mask;
    if (itemReq && itemValue.trim() == '') {
      formItem.classList.add("required");
      control = false;
      formItem.addEventListener("change", function () {
        if (this.value.trim() != '') {
          this.classList.remove("required");
          control = true;
        } else {
          this.classList.add("required");
          control = false;
        }
      });
    }

    if (itemRegExp) {
      if (!regex.exec(itemValue)) {
        if (!formItem.dataset.regexErrCount) {
          formItem.dataset.regexErrCount = "1";
          var span = document.createElement("span");
          span.classList = "error-regex";
          span.innerText = itemRegExpMessage;
          formItem.offsetParent.appendChild(span);
        } else {
          formItem.dataset.regexErrCount = parseInt(formItem.dataset.regexErrCount) + 1;
        }
        control = false;
        formItem.addEventListener("change", function () {
          var itemRegExp = this.dataset.pattern,
              itemRegExpMessage = this.dataset.patternmessage,
              regex = new RegExp(itemRegExp, 'g');
          if (regex.exec(this.value)) {
            var spanDataRegex = this.offsetParent.getElementsByTagName("span");
            for (var i = 0; i < spanDataRegex.length; i++) {
              if (spanDataRegex[i].classList == "error-regex") {
                spanDataRegex[i].remove();
              }
            }
            control = true;
          }
        });
      } else {
        control = true;
      }
    }

    if (control) {
      formItem.classList.add("success");
    } else {
      formItem.classList.remove("success");
    }
  }

  if (control) {
    grecaptcha.reset();
    grecaptcha.execute();
  }
  return false;
}
// Tüm Etkinlikler Daha Fazla
new MoreItems({
  wrapper: "js-event-more",
  items: "event-filter",
  moreBtn: "js-event-more-btn",
  visibleCount: 3
});

if ($(".media-list").length > 6) {
  var media = $(".media-list");
  media.hide();
  media.slice(0, 6).show();
  $("#media-more").click(function () {
    $(".media-list:hidden").slice(0, 6).slideDown();
  });
}

if ($(".newsscroll").length > 6) {
  var news = $(".newsscroll");
  news.hide();
  var newsItem = 6;
  var visibleItems = 0;
  news.slice(0, newsItem).show();
  $("#news-more").click(function () {
    visibleItems += newsItem;
    $(".newsscroll:hidden").slice(0, newsItem).slideDown();
    $('html,body').animate({
      scrollTop: $("#footer").offset().top - 1000
    }, 2500);
    if (visibleItems >= news.length) {
      $("#news-more").hide();
    }
  });
}

if ($(".video-box").length > 9) {
  var videos = $(".video-box");
  videos.hide();
  var showVideos = 9;
  videos.slice(0, showVideos).show();
  if (showVideos >= videos.length) {
    $("#video-more").hide();
  }
  $("#video-more").click(function () {
    $(".video-box:hidden").slice(0, 6).slideDown();
    showVideos += 6;
    if (showVideos >= videos.length) {
      $("#video-more").hide();
    }
    $('html,body').animate({
      scrollTop: $("#footer").offset().top - 1000
    }, 2500);
  });
} else {
  $("#video-more").hide();
}

if ($(".image-box").length > 9) {
  $("#image-more").removeClass("hidden");
  var images = $(".image-box");
  images.hide();
  images.slice(0, 9).show();
  $("#image-more").click(function () {
    $(".image-box:hidden").slice(0, 6).slideDown();
    $('html,body').animate({
      scrollTop: $("#footer").offset().top - 600
    }, 2500);
  });
}
'use strict';

var language = $("body").data("lang");

$(document).ready(function () {

  $("#btn-top").on("click", function () {
    $("html, body").animate({
      scrollTop: 0
    }, 'slow');
  });

  $(".scrollto").on("click", function () {
    $(this).scrollTo();
  });

  // Filter More

  $("#submenu > ul > li").click(function () {
    $("#submenu > ul > li").removeClass("active");
    $(this).addClass("active");
  });

  if ($("#mezun-year-select").length > 0) {
    var getSelectedYear = function getSelectedYear() {

      $('#mezun-slider-filter').slick("slickUnfilter");
      var getSelectYear = mezunYearChoices.getValue();

      var filterMezun = $('#mezun-slider-filter .slick-slide').filter(function () {
        return $(this).data("mezunyear") == getSelectYear.value;
      });

      if (getSelectYear.value != 0) {
        $("#mezun-year").html(getSelectYear.label + " ");
        $("#mezun-slider-filter").slick("slickFilter", filterMezun);
      }

      if (filterMezun.length <= 0) {
        $("#mezun-year").html("");
        $("#mezun-filter-counter").parent("span").addClass("hidden");
        $("#mezun-slider-filter").slick("slickUnfilter");
      } else {
        $("#event-notfound").addClass("hidden");
        $("#mezun-filter-counter").parent("span").removeClass("hidden");
        $("#mezun-filter-counter").html(filterMezun.length);
      }
      return filterMezun;
    };

    var mezunYearSelect = document.getElementById('mezun-year-select');
    var mezunYearChoices = new Choices(mezunYearSelect, {
      duplicateItems: false,
      itemSelectText: '',
      placeholder: true,
      placeholderValue: 0,
      searchPlaceholderValue: 0,
      searchChoices: false,
      searchEnabled: false,
      sortFilter: function sortFilter(a, b) {
        return b.value < a.value;
      }
    });

    mezunYearSelect.addEventListener('change', function (event) {
      getSelectedYear();
    });
  }

  if ($('#event-year-select').length > 0 && $('#event-month-select').length > 0) {
    var getSelectedDate = function getSelectedDate() {
      if (!$("#event-more").hasClass("hidden")) {
        $("#event-more").addClass("hidden");
      }
      var getSelectYear = eventYearChoices.getValue();
      var getSelectMonth = eventMonthChoices.getValue();

      var filterEvent = $('.event-filter').filter(function () {
        if (getSelectMonth.value == 0 && getSelectYear.value == 0) {
          return $(this);
        } else {
          if (getSelectMonth.value == 0) {
            console.log("year");
            return $(this).data("year") == getSelectYear.value;
          }
          if (getSelectYear.value == 0) {
            console.log("month");
            return $(this).data("month") == getSelectMonth.value;
          }
          if (getSelectMonth.value != 0 && getSelectYear.value != 0) {
            console.log("month and year");
            return $(this).data("month") == getSelectMonth.value && $(this).data("year") == getSelectYear.value;
          }
        }
      });

      if (getSelectYear.value == 0 && getSelectMonth.value) {
        $("#date-year").html("Tüm Etkinlikler");
        $("#date-month").html("");
      } else {
        if (getSelectYear.value != 0) {
          $("#date-year").html(getSelectYear.label + " ");
        } else {
          $("#date-year").html("");
        }
        if (getSelectMonth.value != 0) {
          $("#date-month").html(getSelectMonth.label);
        } else {
          $("#date-month").html("");
        }
      }
      if (filterEvent.length <= 0) {
        $("#event-notfound").removeClass("hidden");
        $("#filter-count").addClass("hidden");
      } else {
        $("#event-notfound").addClass("hidden");
        $("#filter-count").removeClass("hidden").html(filterEvent.length + " Etkinlik Günü Bulundu");
      }
      return filterEvent;
    };

    var eventYearSelect = document.getElementById('event-year-select');
    var eventYearChoices = new Choices(eventYearSelect, {
      itemSelectText: '',
      placeholder: false,
      placeholderValue: 0,
      searchPlaceholderValue: 0,
      searchChoices: false,
      searchEnabled: false
    });

    var eventMonthSelect = document.getElementById('event-month-select');
    var eventMonthChoices = new Choices(eventMonthSelect, {
      itemSelectText: '',
      placeholder: false,
      placeholderValue: 0,
      searchPlaceholderValue: 0,
      searchChoices: false,
      searchEnabled: false
    });

    eventYearSelect.addEventListener('change', function (event) {
      $('.event-filter').addClass('hidden');
      getSelectedDate().removeClass("hidden");
    });

    eventMonthSelect.addEventListener('change', function (event) {
      $('.event-filter').addClass('hidden');
      getSelectedDate().removeClass("hidden");
    });
  }

  // Menu Start
  $("#mobil-menu-btn").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $("body").css({
        overflow: "auto"
      });
      $("#mobile-nav").removeClass("open");
    } else {
      $(this).addClass("active");
      $("body").css({
        overflow: "hidden"
      });
      $("#mobile-nav").addClass("open");
    }
  });

  if ($('#header-sticky').length > 0) {
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 300) {
        $('#header-sticky').addClass('stuck');
      } else {
        $('#header-sticky').removeClass('stuck');
      }
    });
  }
});
// \ Menu End

// Popup
if ($('.video-link').length > 0) {
  $('.video-link').magnificPopup({
    type: 'iframe'
  });
}
if ($('.iframe').length > 0) {
  $('.iframe').magnificPopup({
    type: 'iframe',
    fixedContentPos: true
  });
}

if ($('.open-popup-link').length > 0) {
  $('.open-popup-link').magnificPopup({
    type: 'inline',
    midClick: true
  });
}

if (window.location.pathname == '/tbsvelileri' || window.location.pathname == '/tbsparents') {
  window.loginOpen = function () {
    $.magnificPopup.open({
      items: {
        src: $('#login-panel')
      }
    });
  };
  window.loginClose = function () {
    $.magnificPopup.close({
      items: {
        src: $('#login-panel')
      }
    });
  };
  var login = getCookie("login");
  if (login == "false" || !login) {
    $("#unautorize").removeClass("hidden");
    window.loginOpen();
  } else {
    var sinif = getCookie("sinif");
    $("#login").removeClass("hidden");
    $("#tbsVelileriForm input[name='classname']").val(sinif);
  }
  $(".login-popup").click(function () {
    window.loginOpen();
  });
}

if ($('.image-link').length > 0) {
  $('.image-link').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true
    },
    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
      opener: function opener(openerElement) {
        return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  });
}
// \ Popup

// Custom Select
if ($('.js-choice').length > 0) {
  new Choices('.js-choice', {
    duplicateItems: false,
    shouldSort: false,
    itemSelectText: '',
    placeholder: true,
    placeholderValue: 0,
    searchPlaceholderValue: 0,
    searchChoices: false,
    searchEnabled: false
  });
}
// \ Custom Select
$(window).on("load", function () {

  // Maps
  if ($("#map").length > 0) {

    $.fn.lsvrGoogleMapsLoaded = function () {

      var iconImg = "/assets/images/mapsmarker.png";
      var map = new google.maps.Map(document.getElementById('map'), {
        mapTypeId: 'roadmap',
        styles: [{
          "elementType": "geometry",
          "stylers": [{
            "color": "#f5f5f5"
          }]
        }, {
          "elementType": "labels.icon",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#616161"
          }]
        }, {
          "elementType": "labels.text.stroke",
          "stylers": [{
            "color": "#f5f5f5"
          }]
        }, {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#bdbdbd"
          }]
        }, {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [{
            "color": "#eeeeee"
          }]
        }, {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#757575"
          }]
        }, {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [{
            "color": "#e5e5e5"
          }]
        }, {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#9e9e9e"
          }]
        }, {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{
            "color": "#ffffff"
          }]
        }, {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#757575"
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [{
            "color": "#dadada"
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#616161"
          }]
        }, {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#9e9e9e"
          }]
        }, {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [{
            "color": "#e5e5e5"
          }]
        }, {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [{
            "color": "#eeeeee"
          }]
        }, {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "color": "#c9c9c9"
          }]
        }, {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#9e9e9e"
          }]
        }]
      }),
          markers = new Array(),
          maplng = new Array(),
          maplat = new Array(),
          markerCount = 0;
      $.get("/KampusXML", function (res) {
        var campuses = $(res).find("campuses").find("campus");
        $.each(campuses, function (index, campus) {
          var title = $(campus).find("title")[0].textContent,
              mapCode = $(campus).find("googlemap")[0].textContent.split(',');
          if (mapCode.length > 1) {
            var latlng = new google.maps.LatLng(mapCode[0], mapCode[1]);
            maplat.push(Number(mapCode[0]));
            maplng.push(Number(mapCode[1]));
            markerCount++;
            markers[markerCount] = new google.maps.Marker({
              position: latlng,
              icon: iconImg,
              title: title,
              map: map
            });
          }
        });
      }).done(function () {
        var lng_min = Math.min.apply(Math, maplng);
        var lng_max = Math.max.apply(Math, maplng);
        var lat_min = Math.min.apply(Math, maplat);
        var lat_max = Math.max.apply(Math, maplat);
        map.setCenter(new google.maps.LatLng((lat_max + lat_min) / 2.0, (lng_max + lng_min) / 2.0));
        map.fitBounds(new google.maps.LatLngBounds(new google.maps.LatLng(lat_min, lng_min), new google.maps.LatLng(lat_max, lng_max)));
        markers.map(function (marker) {
          var infowindow = new google.maps.InfoWindow({
            content: '<i class="icon icon-contact-icon" style="color:#ed0021; font-size: 50px;display:inline-block;vertical-align:middle;"></i>' + '<span style="display:inline-block;vertical-align:middle;font-size:14px;font-weight:500;padding:10px;">' + marker.title + '</span>'
          });
          marker.addListener("click", function () {
            infowindow.open(map, marker);
          });
        });
      });
    };

    var googlemapkey = $("#map").data("key");
    if (googlemapkey) {
      var script = document.createElement('script');
      script.className = 'googleMapsApiScript';
      script.type = 'text/javascript';
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + googlemapkey + '&callback=jQuery.fn.lsvrGoogleMapsLoaded';
      document.body.appendChild(script);
    } else {
      console.log("Google Map Key Error!");
    }
  }
  // \Maps
});

// Maps Show Hide
$(document).on("click", function (event) {
  if (!$(event.target).closest('.homemap').length) {
    $("#section-map").removeClass("mapon");
  } else {
    $("#section-map").addClass("mapon");
  }
});

$("#AppointmentBtn").on("click", function () {
  $("#homeContactSection").addClass("hidden");
  $("#homeAppointmentSection").removeClass("hidden");
});

$("#closeRandevu1,#closeRandevu2").on("click", function () {
  $("#homeContactSection").removeClass("hidden");
  $("#homeAppointmentSection").addClass("hidden");
});

// \ Maps Show Hide

// Facebook Video
(function (d, s, id) {
  var js,
      fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.6";
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');
// \Facebook Video

// Preloader
if ($("#loadingwrap").length > 0) {
  window.onloadeddata = function () {
    $("body").css("overflow", "auto");
    $("#loadingwrap").hide();
  };
}
// \Preloader
$(function () {
  $(".inputSearch").keyup(function () {
    var searchVal = $(this).val();
    if (searchVal.length > 2) {
      $.get("/search-autocomplate", {
        q: searchVal
      }).done(function (res) {
        $("#search-result ul").html("");
        $(res).find("item").each(function (index, item) {
          var $title = $(this).find("title").text(),
              $link = $(this).find("link").text();
          var listItem = document.createElement("li"),
              linkItem = document.createElement("a"),
              containerItem = document.createElement("div");
          containerItem.classList = "container";
          linkItem.innerText = $title;
          linkItem.href = $link;
          if (index > 5) {
            // linkItem.innerText = "Dahafazlasını Görmek İçin Tıklayınız.";
            // linkItem.href = "/arama-sonuclari?q=" + searchVal;
            // containerItem.appendChild(linkItem);
            // listItem.appendChild(containerItem);
            // $("#search-result ul").append(listItem);
            return false;
          } else {
            containerItem.appendChild(linkItem);
            listItem.appendChild(containerItem);
            $("#search-result ul").append(listItem);
          }
        });
      }).fail(function (err) {
        console.log(err);
      });
    } else {
      $("#search-result ul").html("");
    }
  });
});

$(".searchBoxButton").click(function () {
  if ($(".search-box").hasClass("open")) {
    $(".search-box").removeClass("open");
    $(".submenu").removeClass("search-open");
  } else {
    $(".search-box").addClass("open");
    $(".submenu").addClass("search-open");
  }
});

function popupImageGallery(categoryname) {
  $.get("/imagegalleryxml?q=" + categoryname, function (res) {
    var items = $(res).find("item");
    var _items = [];
    console.log(items);
    $.each(items, function (index, item) {
      if ($(item).attr("type") == "flickr") {
        if (!document.getElementById("flickrscript")) {
          var script = document.createElement('script');
          script.id = 'flickrscript';
          script.type = 'text/javascript';
          script.async = true;
          script.charset = "utf-8";
          script.src = '//embedr.flickr.com/assets/client-code.js';
          document.body.appendChild(script);
        } else {
          var script = document.getElementById("flickrscript");
          document.body.removeChild(document.getElementById("flickrscript"));
          document.body.appendChild(script);
        }
        var flickrembed = $(item).find("embedcode")[0];
        _items.push({
          type: 'inline',
          src: $("<div>" + flickrembed.textContent + "</div>")
        });
      }
      if ($(item).attr("type") == "images") {
        $.each($(item).find("imgs"), function (index, img) {
          _items.push({
            src: $(img).find("src").text(),
            type: 'image'
          });
        });
      }
    });
    $.magnificPopup.open({
      items: _items,
      gallery: {
        enabled: true
      },
      type: 'image',
      callbacks: {
        close: function close() {
          document.body.removeChild(document.getElementById("flickrscript"));
        }
      }
    });
  });
}

var scrollTop = function scrollTop() {
  var $selector = $('.js-top-anchor');
  $selector.click(function () {
    $('html, body').animate({ scrollTop: 0 }, 600);
    return false;
  });
};

scrollTop();

var fixedHeader = function fixedHeader() {
  var $stickyOffset = $('.header').height();
  var $header = $('.header');
  $(window).scroll(function () {
    if ($(window).scrollTop() >= $stickyOffset) {
      $header.addClass('fixed');
    } else {
      $header.removeClass('fixed');
    }
  });
};

var searchToggle = function searchToggle() {
  var $selector = $('.js-search-btn');
  $selector.click(function () {
    document.body.classList.toggle('search-open');
    $('#js-search-input').focus();
  });
};

fixedHeader();
searchToggle();

var simpleMenu = function simpleMenu() {
  $('.hamburger-menu').click(function () {
    $('body').toggleClass('menu-open');
  });
};

simpleMenu();

var menuCloseBtn = function menuCloseBtn() {
  $('.js-menu-close').click(function () {
    if ($('body').hasClass('menu-open')) {
      $('body').removeClass('menu-open');
    }
  });
};

menuCloseBtn();

var headerAccordion = function headerAccordion() {
  var $selectors = $('.submenu__head');

  var _loop3 = function _loop3(i) {
    var selector = $selectors[i];
    selector.onclick = function () {
      selector.classList.toggle('submenu--open');
    };
  };

  for (var i = 0; i < $selectors.length; i += 1) {
    _loop3(i);
  }
};

headerAccordion();

var App = function () {
  function App() {
    _classCallCheck(this, App);

    this.Body = document.body;
    this.width = document.body.clientWidth;
    this.language = $('body').data('lang') || 'tr';
  }

  _createClass(App, [{
    key: 'lang',
    get: function get() {
      return this.language;
    }
  }, {
    key: 'size',
    get: function get() {
      if (this.width <= 468) {
        return 'mobile';
      } else if (this.width <= 768) {
        return 'tablet';
      }
      return 'desktop';
    }
  }, {
    key: 'body',
    get: function get() {
      return $('body');
    }
  }, {
    key: 'bodyClasses',
    get: function get() {
      return this.Body.classList;
    },
    set: function set(value) {
      $('body').addClass(value);
    }
  }]);

  return App;
}();

// Base Application


var Application = new App();

// Application Add Responsive Class
Application.bodyClasses = Application.size;

window.Application = Application;

var JSLink = function () {
  var dataLink = function dataLink() {
    window.onload = function () {
      var links = document.querySelectorAll('[data-link]');

      var _loop4 = function _loop4(i) {
        var linkItem = links[i];
        linkItem.addEventListener('click', function () {
          var link = linkItem.dataset.link;
          var target = linkItem.dataset.target;
          if (link) {
            window.open(link, target);
          }
        });
      };

      for (var i = 0; i < links.length; i += 1) {
        _loop4(i);
      }
    };
  };

  var init = function init() {
    dataLink();
  };

  return {
    init: init
  };
}();

JSLink.init();

var Print = function () {
  var printPopup = function printPopup(selector) {
    var content = $(selector).html();
    var style = '<style>@media print {\n        .btn, button{\n          display: none;\n        }\n      }</style>';
    var mywindow = window.open('', 'PRINT');
    mywindow.moveTo(0, 0);
    mywindow.resizeTo(screen.width, screen.height);
    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write(style + '</head><body >');
    mywindow.document.write(content);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  };

  var init = function init() {
    window.printPopup = printPopup;
  };

  return {
    init: init
  };
}();

Print.init();

var BannerVideo = function () {

  var mobileBanner = function mobileBanner() {
    var $selector = $('#banner');

    if ($('body').width() <= 468) {
      $selector.find('video').remove();
      $selector.find('img').removeClass('hidden');
    }
  };

  var init = function init() {
    mobileBanner();
  };

  return {
    init: init
  };
}();

BannerVideo.init();